import { render, staticRenderFns } from "./PageStadiumFields.vue?vue&type=template&id=81b09f06&"
import script from "./PageStadiumFields.vue?vue&type=script&lang=js&"
export * from "./PageStadiumFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81b09f06')) {
      api.createRecord('81b09f06', component.options)
    } else {
      api.reload('81b09f06', component.options)
    }
    module.hot.accept("./PageStadiumFields.vue?vue&type=template&id=81b09f06&", function () {
      api.rerender('81b09f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageStadiumFields.vue"
export default component.exports